export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14333.5c5e2d1a.jpg";